import { useEffect, useState } from "react";
import styled from "styled-components";
import MessageModal from "../components/MessageModal";
import { validateEmail } from "../utils/helperfunctions";
import Button from "../components/Button";
import { fetchWrapper } from "../utils/apiHandlers";
import { userContext } from "../usercontext";

interface Props{
  history?: any;
  location?: any;
}

const Register: React.FC<Props> = (props) => {
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [modalheader, setmodalheader] = useState('');
  const [modalmessage, setmodalmessage] = useState('');
  const [modalstate, setmodalstate] = useState(false);
  const [token, settoken] = useState('');
  const [linkrequested, setlinkrequested] = useState(false);
  const [checkingtoken, setcheckingtoken] = useState(true);
  const [tokenvalid, settokenvalid] = useState(false);
  const [ registrationsuccessful, setregistrationsuccessful ] = useState(false)


  const openModal = (header: string, message: string, progress?: boolean) => {
    setmodalheader(header)
    setmodalmessage(message);
    setmodalstate(true);
  }

  const register = async () => {
    let response = await userContext.register(email, token, password).then((r: any)=>r)
    console.log(`response : ${JSON.stringify(response)}`)

    if(!response){
      openModal("Warning", "This link is no longer valid, please request a new one.")
      return
    }
    setregistrationsuccessful(true)
  }

  const requestlink = async () => {
    if(!validateEmail(email)){
      openModal("Error", "Invalid email address.")
      return;
    }

    const body = {
        email: email,
    }
    await fetchWrapper.post("/api/authenticate/sendregistrationlink", body).then((res:any) => {
      if(res.status==200){
          setlinkrequested(true);
          openModal("Message", res.msg);
        }else{
          openModal("Error", res.msg);
      }

    }).catch((error:any)=> {
        console.log(error)
        openModal("Error", "Failed, please try again.");
      })
  }

  useEffect (()=> {
    let user = JSON.parse(localStorage.getItem('user')||'{}')
    if(user && user.status==200){
      props.history.push("/dashboard")
      return
    }

    const params = new URLSearchParams(props.location?.search || window.location.search)
    const urltoken = params.get('token')
    if(!urltoken){
      setcheckingtoken(false)
      return
    }

    settoken(urltoken)
    fetchWrapper.post("/api/authenticate/verifyregistrationtoken", { token: urltoken }).then((res: any) => {
      if(res.status==200){
        setemail(res.email)
        settokenvalid(true)
      }else{
        openModal("Link expired", res.msg)
      }
      setcheckingtoken(false)
    }).catch(() => {
      openModal("Error", "Could not verify this link, please request a new one.")
      setcheckingtoken(false)
    })
  }, [])

  useEffect(()=>{
    if(!registrationsuccessful)return
    let user: any = localStorage.getItem("user")

    user = JSON.parse(user)
    console.log(`user : ${JSON.stringify(user)}`)
    if(user && user.status==200){
      props.history.push("/dashboard")
    }
  }, [registrationsuccessful])

  return(
    <MainContainer>
          <MessageModal header={modalheader} message={modalmessage} state={modalstate} handleClose={()=> setmodalstate(false)}/>
          <Header>Register</Header>
          {checkingtoken?
            <SubText>Checking your link...</SubText>
          :tokenvalid?
            <>
            <SubText>Finishing registration for {email}</SubText>
            <Input type="password" placeholder="choose a password" value={password} onChange={(e) => setpassword(e.target.value)} autoComplete={"new-password"} />
            <Button handleClick={register} text="Complete Registration"/>
            </>
          :linkrequested?
            <SubText>Check your email for a link to finish creating your account.</SubText>
          :
            <>
            <SubText>Enter your email and we'll send you a link to finish creating your account.</SubText>
            <Input placeholder="email" value={email} onChange={(e) => setemail(e.target.value)} autoComplete={"off"} />
            <Button handleClick={requestlink} text="Send Registration Link"/>
            </>
          }
  </MainContainer>
  );
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-top:-100px;
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 5px;
`

export const Column = styled.div`
  padding: 50px;
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #ffffff;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`
const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubText = styled.div`
    max-width: 320px;
    text-align: center;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
`;

const SubHeader = styled.div`
    font-weight: 700;
    font-size: 25px;
    justify-content: flex-end;
`;

// const Button = styled.div`
//   margin: 5px;
//   display: flex;
//   justify-content: center;
//   text-align: center;
//   font-size: 16px;
//   cursor: pointer;
//   text-transform: uppercase;
//   padding: 10px;
//   font-weight: 700;
//   border-radius: 3px;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
//   background-color: #5faad4;
//   min-width: 75px;
//   transition: ease 0.5s;
//   &:hover {
//     font-weight: 700;
//     background-color: #212122;
//   }
// `

// const SmallButton = styled.div`
//   margin: 5px;
//   display: flex;
//   justify-content: center;
//   text-align: center;
//   font-size: 12px;
//   cursor: pointer;
//   text-transform: uppercase;
//   padding: 7px;
//   font-weight: 500;
//   border-radius: 3px;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
//   background-color: #4D2FA2;
//   min-width: 50px;
//   transition: ease 0.5s;
//   &:hover {
//     font-weight: 700;
//     background-color: #212122;
//   }
// `
const ButtonDiv = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const Input = styled.input`
    padding: 10px;
    background-color: #eee;
    border: 1px solid black;
    margin: 10px;
    width: 250px;
    border-radius: 3px;
`

export default Register;
